import React, { useEffect, useState, useRef } from "react";
import { getEnv } from "@/utils";
import PubSub from "pubsub-js";
import intl from "react-intl-universal";
import { Progress } from "antd";
import { Cookie } from "@/utils/cookie";

import styles from "./LogContainer.module.scss";

const LogContainer = () => {
  const [searchValue, setSearchValue] = useState("");
  const [logItems, setLogItems] = useState([]);
  const wsRef = useRef<WebSocket | null>(null);
  const timeRef = useRef<any>(null);

  const apiHost = {
    dev: "wss://test.seller.9five.ai",
    test: "wss://test.seller.9five.ai",
    uat: "wss://test.seller.9five.ai",
    prod: "wss://seller.9five.ai",
  };

  const url =
    process.env.NODE_ENV === "development" ? apiHost.dev : apiHost[getEnv()];

  useEffect(() => {
    const connectWebSocket = () => {
      const ws = new WebSocket(
        `${url}/api/web/merchant/ws?authorization=${Cookie.get("token")}`
      );
      wsRef.current = ws;

      ws.onopen = () => {
        console.log("WebSocket connected");
        timeRef.current = setInterval(() => {
          ws.send("ping");
        }, 30000);
      };

      ws.onmessage = (event) => {
        try {
          console.log(JSON.parse(event.data));
          const newLogItem = JSON.parse(event.data);
          if (newLogItem.type === "TK_CHECK_ENV_RESULT") {
            // 登录商家后台，通知环境配置刷新
            PubSub.publish("TK_CHECK_ENV_RESULT", { ...newLogItem });
            return;
          }
          if (newLogItem.type === "SHOP_INITIALIZE_SUCCESS") {
            PubSub.publish("SHOP_INITIALIZE_SUCCESS", { ...newLogItem });
            return;
          }
          if (newLogItem.type === "SHOP_INITIALIZE_FAIL") {
            PubSub.publish("SHOP_INITIALIZE_FAIL", { ...newLogItem });
            return;
          }

          if (newLogItem.type === "LOGIN_CLIENT") {
            PubSub.publish("LOGIN_CLIENT", { ...newLogItem });
            return;
          }

          if (newLogItem.type === "LOGOUT_CLIENT") {
            PubSub.publish("LOGOUT_CLIENT", { ...newLogItem });
            return;
          }

          if (newLogItem.type === "SWITCH_SHOP") {
            // 检测切换店铺
            sessionStorage.removeItem("firstModal");
            setTimeout(() => {
              alert(intl.get("log_shopSwitchAlert"));
              window.location.reload();
            }, 500);

            return;
          }
          if (newLogItem.type === "TASK_FINISHED_CREATOR_HISTORY") {
            // 达人搜索历史完成（刷新搜索达人列表）
            PubSub.publish("TASK_FINISHED_CREATOR_HISTORY", {});
          }
          if (newLogItem.type === "TASK_FINISHED_CREATOR_INFO_CONTACTING") {
            // 获取达人最新数据-建联中（刷新我的达人-全部或建联中列表）
            PubSub.publish("TASK_FINISHED_CREATOR_INFO_CONTACTING", {});
          }
          if (newLogItem.type === "TASK_FINISHED_CREATOR_INFO_SUCCESS") {
            // 获取达人最新数据-建联成功（刷新我的达人-全部或建联成功列表）
            PubSub.publish("TASK_FINISHED_CREATOR_INFO_SUCCESS", {});
          }

          if (newLogItem.type === "TASK_FINISHED_CREATOR_INFO_VISIT") {
            // 获取达人最新数据-来访达人（刷新我的达人-来访达人列表）
            PubSub.publish("TASK_FINISHED_CREATOR_INFO_VISIT", {});
          }
          if (newLogItem.type === "TASK_FINISHED_SAMPLE_REQ") {
            // 更新样品数据（刷新样品数据列表）
            PubSub.publish("TASK_FINISHED_SAMPLE_REQ", {});
          }
          if (newLogItem.type === "TASK_FINISHED_SAMPLE_REQ_APPROVAL_SUCCESS") {
            // 更新样品数据（刷新样品数据列表）
            PubSub.publish("TASK_FINISHED_SAMPLE_REQ_APPROVAL_SUCCESS", {});
          }

          if (newLogItem.type === "TASK_FINISHED_OPEN_COLL") {
            // 刷新商品卡（我的达人-发送消息-Products）数据列表
            PubSub.publish("TASK_FINISHED_OPEN_COLL", {});
          }
          if (newLogItem.type === "TASK_FINISHED_TARGET_COLL") {
            // 刷新定向合作（我的达人-发送消息-Target Collaborations）数据列表
            PubSub.publish("TASK_FINISHED_TARGET_COLL", {});
          }

          if (newLogItem.type === "TASK_FINISHED_CREATOR_INFO_IMPORT") {
            // 刷新我的达人-导入达人数据列表
            PubSub.publish("TASK_FINISHED_CREATOR_INFO_IMPORT", {});
          }

          if (newLogItem.type === "TASK_FINISHED_IMPORT_CREATOR") {
            // 刷新我的达人-导入达人数据列表
            PubSub.publish("TASK_FINISHED_IMPORT_CREATOR", {});
          }

          if (newLogItem.type === "TASK_FINISHED_OPEN_COLL_SUCCESS") {
            // 获取公开合作产品任务-成功后消息类型
            PubSub.publish("TASK_FINISHED_OPEN_COLL_SUCCESS", {});
          }
          if (newLogItem.type === "TASK_FINISHED_OPEN_COLL_FAIL") {
            // 获取公开合作产品任务-失败后消息类型
            PubSub.publish("TASK_FINISHED_OPEN_COLL_FAIL", {});
          }

          if (newLogItem.type === "TASK_FINISHED_TARGET_COLL_SUCCESS") {
            // 获取定向合作产品任务-成功后消息类型
            PubSub.publish("TASK_FINISHED_TARGET_COLL_SUCCESS", {});
          }
          if (newLogItem.type === "TASK_FINISHED_TARGET_COLL_FAIL") {
            // 获取定向合作产品任务-失败后消息类型
            PubSub.publish("TASK_FINISHED_TARGET_COLL_FAIL", {});
          }
          if (newLogItem.type === "TASK_SAMPLE_FETCH_CREATOR_SUCCESS") {
            // 样品审批消息类型
            PubSub.publish("TASK_SAMPLE_FETCH_CREATOR_SUCCESS", {});
          }

          if (newLogItem.type === "TK_CHECK_ENV_RESULT") {
            // 店铺登录成功
            if (newLogItem?.data?.hasLogin) {
              PubSub.publish("TK_CHECK_ENV_RESULT", {});
            }
          }
          if (newLogItem.type !== "TK_EXECUTION_LOG") {
            return;
          }

          if (
            logItems.length &&
            logItems[0].data.rpaTaskId !== newLogItem.data.rpaTaskId
          ) {
            setLogItems(() => [newLogItem]);
          } else {
            setLogItems((prevItems) => [newLogItem, ...prevItems]);
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", error);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket closed, retrying in 1 seconds...");
        clearInterval(timeRef.current);
        setTimeout(connectWebSocket, 1000);
      };
    };

    connectWebSocket();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  return (
    <>
      <div className={styles.content}>
        {/* 搜索日志输入框 */}
        {/* <div className={styles.searchInput}>
          <Search
            placeholder="搜索日志..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onSearch={() => console.log("search:", searchValue)}
            enterButton
          />
          <SyncOutlined className={styles.refreshBtn} />
        </div> */}
        {logItems.length &&
        logItems[0].data?.executionNum &&
        logItems[0].data?.targetsNum ? (
          <div className={styles.info}>
            <div className={styles.infoheader}>
              <p>{intl.get("log_executionProgress")}</p>
              <span>
                {(
                  (logItems[0].data?.executionNum /
                    logItems[0].data?.targetsNum) *
                  100
                ).toFixed(2)}
                %
              </span>
            </div>
            <Progress
              percent={
                (logItems[0].data?.executionNum /
                  logItems[0].data?.targetsNum) *
                100
              }
              status="active"
              showInfo={false}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // marginTop: "10px",
              }}
            >
              <div className={styles.infoItem}>
                <p>{intl.get("log_targetCount")}</p>
                <span>{logItems[0].data?.targetsNum}</span>
              </div>
              <div className={styles.infoItem}>
                <p>{intl.get("log_executedCount")}</p>
                <span>{logItems[0].data?.executionNum}</span>
              </div>
            </div>
          </div>
        ) : null}

        <div
          className={`${styles.logContent} ${
            logItems.length &&
            (logItems[0].data?.executionNum || logItems[0].data?.targetsNum) &&
            styles.logContentWithInfo
          }`}
        >
          {logItems.map((item, index) => {
            if (!item?.data?.remark) {
              return null;
            }
            return (
              <div key={index} className={styles.listItem}>
                <p>{item?.data?.logTime}</p>
                <div>
                  {item?.data?.remark}
                  {index === 0 ? "..." : ""}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default LogContainer;
